import React from 'react'
import PropTypes from 'prop-types'
import { Box, Copy } from '@elparking/components'

const Feature = ({ icon, text, display }) => <Box mb='0.5em' pR='1em' display={display} alignItems='center'>
    <Box>
        { icon }
    </Box>
    <Copy as='span' padding='0 1em 0 0.5em' fontWeight='book' fontColor='gray90' fontSize='xSmall'>
        {text}
    </Copy>
</Box>

Feature.defaultProps = {
    display: 'inline-flex',
}

Feature.propTypes = {
    icon: PropTypes.node,
    text: PropTypes.node,
    display: PropTypes.string,
}

export default Feature
